module.exports = __webpack_public_path__ + "assets/images/tri_g.623bd12b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/tri_g.png
// module id = 771
// module chunks = 1